import React from 'react';
import {connect} from 'react-redux';
import {Navbar, NavDropdown} from 'react-bootstrap';
import {accionColectivaActions, alertActions, consultaActions, userActions} from '../_actions';
import Logo from './Logo';
import {Link} from 'react-router-dom';
import Switch from "react-switch";
import {alertConfirm} from '../_helpers';
import authService from '../_services/authService';

class NavBar extends React.Component {
    constructor() {
        super();
        this.state = {checked: false};
        this.handleChange = this.handleChange.bind(this);
        this.wrapperRef = React.createRef();
    }

    handleChange(checked) {
        if (checked) {
            document.body.classList.remove('bg-oscuro');
            document.body.classList.add('modo-claro');
        } else {
            document.body.classList.remove('modo-claro');
            document.body.classList.add('bg-oscuro');
        }
        this.setState({checked});
    }

    state = {
        show: false,
        showDetalle: false,
        showNotificacion: false,
        showPagarSuscripcion: false,
        pasePrimeraVez: false
    };

    pagarSuscripcion = () => {
        this.setState({showPagarSuscripcion: true, showDetalle: false});
    };

    abrirNotificacion = () => {
        this.setState({showNotificacion: true});
    };

    handleClose = () => {
        this.setState({show: false, showDetalle: false, showNotificacion: false, showPagarSuscripcion: false});
    };
    handleCloseBurbuja = () => {
        this.props.limpiarBurbujaConsulta();
    };

    handleShow = () => {
        this.setState({show: true});
    };

    manejarSubmitEquipo = () => {
        this.setState({show: false});
    };

    mostrarDetalleLicencia = () => {
        this.setState({showDetalle: true});
    };


    componentDidMount() {

        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.props.cerrarGlobo();
        }
    }

    confirmEjecucion = (accion) => {
        const getAlert = alertConfirm('Confirmar',
            `¿Está seguro que desea ejecutar ${accion.item.nombre}?`,
            'Sí, ejecutar',
            'Cancelar',
            this.props.clearAlertConfirm,
            () => this.ejecutarAccion(accion),
            null,
            true,
            'warning',
            true
        )
        this.props.enviarAlertConfirm(getAlert);
    }


    ejecutarAccion = (accion) => {
        this.props.ejecutarAccion(accion.item);
    };


    render() {
        const {user} = this.props;

        let soyUsuarioEmpresa = false;

        return (
            <>
                <Navbar className="bg-navbar" sticky="top" expand="lg">
                    <div className="theme-mode d-none d-lg-block d-md-block d-xl-block small text-muted">
                        <span className="material-icons">settings</span>
                        <label htmlFor="small-radius-switch">
                            <Switch
                                checked={this.state.checked}
                                onChange={this.handleChange}
                                handleDiameter={25}
                                offColor="#224f6d"
                                onColor="#9cd6ef"
                                offHandleColor="#00f2c3"
                                onHandleColor="#ffffff"
                                height={30}
                                width={60}
                                activeBoxShadow="0px 0px 1px 2px #fffc35"
                                uncheckedIcon={
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "100%",
                                            fontSize: 15,
                                            color: "silver",
                                            paddingRight: 2
                                        }}
                                    >
                                        <span className="material-icons txt-18">brightness_2</span>
                                    </div>
                                }
                                checkedIcon={
                                    <span
                                        className="material-icons txt-18 text-warning mt-e ml-e">brightness_7</span>
                                }
                                uncheckedhandleicon={
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "100%",
                                            fontSize: 20
                                        }}
                                    >
                                        <span className="material-icons mt-2 ml-2 text-iot">wb_sunny</span>
                                    </div>
                                }
                                className="react-switch"
                                id="small-radius-switch"
                            />
                        </label>
                    </div>
                    <Link to={user ? '/home/misEquipos' : '/login'}>
                        <Navbar.Brand>
                            <Logo empresa={user?.empresa}/>
                        </Navbar.Brand>
                    </Link>

                    {authService.isAuthenticated() &&
                    <>
                        <div>
                            <div className="derecha move">
                                <ul className="">
                                    <li className="nav-item ml-3 mt-3 d-lg-block d-xl-block d-none text-truncate">
                                        <a className="nav-link font-weight-light" href="#">
                                            <p className="font-weight-bold scrolling text-truncate mt-3">
                                                <i className="fas fa-user-circle"></i> Usuario {user?.username} <br></br>
                                                {process.env.NODE_ENV !== 'production' &&
                                                <span
                                                    className="font-weight-light">AMBIENTE:<b>{process.env.NODE_ENV}</b></span>
                                                }
                                            </p>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="drop-nav">
                            <NavDropdown id="basic-nav-dropdown"
                                         title={<div><i className="fas fa-ellipsis-v"></i></div>}>
                                <NavDropdown.Item className="text-oscuro">
                                    <Link to="/perfil/misDatos"> <i
                                        className="material-icons-outlined icon-image-preview align-sub">account_circle</i> Mi
                                        perfil</Link>
                                </NavDropdown.Item>
                                {authService.hasAuthority("ROLE_USER_ADMIN") && 
                                <>
                                <NavDropdown.Item>
                                    <Link to="/perfil/usuarios">
                                        <i className="material-icons-outlined icon-image-preview align-sub">group_work</i> Mis
                                        usuarios
                                    </Link>
                                </NavDropdown.Item>
                                <NavDropdown.Divider/></>}
                                
                                <NavDropdown.Item>
                                    <Link to="/logout">
                                        <i className="material-icons-outlined icon-image-preview align-sub text-danger">exit_to_app</i> Salir
                                    </Link>
                                </NavDropdown.Item>
                            </NavDropdown>
                        </div>
                    </>
                    }
                </Navbar>
            </>
        );
    }
}

function mapState(state) {
    const {authentication, accionColectiva} = state;
    const {user} = authentication;
    return {user};
}

const actionCreators = {
    logout: userActions.logout,
    getConsultasPU: consultaActions.getConsultasPU,
    limpiarBurbujaConsulta: consultaActions.limpiarBurbujaConsulta,
    toogleGlobo: consultaActions.toogleGlobo,
    cerrarGlobo: consultaActions.cerrarGlobo,
    ejecutarAccion: accionColectivaActions.ejecutarAccion,
    enviarAlertConfirm: alertActions.enviarAlertConfirm,
    clearAlertConfirm: alertActions.clearAlertConfirm,
    getAccionesColectivasPU: accionColectivaActions.getAccionesColectivasPU
}

const connectedNavBar = connect(mapState, actionCreators)(NavBar);
export {connectedNavBar as NavBar};
